module.exports = __webpack_public_path__ + "img/short01.a8bcb0c0.png";